import { useCallback, useMemo } from "react"
import { useNavigate } from "react-router-dom"

import { ContractDetailStore } from "src/views/contracts/pages/details/store"
import { useStore } from "src/store/lib/useStore"

export const useContractDetail = () => {
    const navigate = useNavigate()
    const store = useStore(ContractDetailStore)

    const handleBackClick = useCallback(() => {
        navigate("/contracts")
    }, [navigate])

    const handleSimulateTenant = useCallback(async (tenantId?: number) => {
        if (Boolean(tenantId)) {
            await store.simulateUser(tenantId)
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    const contract = useMemo(() => store.contract, [store.contract])

    return {
        contract,
        handleBackClick,
        handleSimulateTenant,
    }
}
